import React from "react";

const PrivacyModal = ({ onClose }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <div
        style={{
          width: "90%",
          maxWidth: "600px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "30px",
          boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
          textAlign: "center",
        }}>
        <h2 style={{ fontSize: "20px", color: "#444", marginBottom: "20px" }}>
          개인정보 수집 및 이용에 동의
        </h2>
        <ul
          style={{
            fontSize: "15px",
            color: "#333",
            textAlign: "left",
            lineHeight: "1.8",
          }}>
          <li>
            1. 수집/이용 목적 : 주문, 예약, 문의 등 고객요청 처리 및 결과 회신
          </li>
          <li>2. 수집하는 항목 : 이름, 연락처, 주소, 이메일</li>
          <li>3. 보유 / 이용 기간 : 고객요청 처리 후 3개월</li>
        </ul>
        <button
          onClick={onClose}
          style={{
            marginTop: "30px",
            padding: "10px 20px",
            backgroundColor: "#f3c6d3",
            color: "#333",
            border: "none",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
          }}>
          닫기
        </button>
      </div>
    </div>
  );
};

export default PrivacyModal;
